module.exports = __webpack_public_path__ + "img/loader-crumb1.628c385e.svg";